<template>
    <div v-if="show" class="page-loading" @click.stop>
        <van-loading type="spinner" color="#1989fa" />
    </div>
</template>

<script>
export default {
    name: 'page-loading',
    data () {
        return {
            show: false
        }
    },
    methods: {
        open () {
            this.show = true
        },
        close () {
            this.show = false
        }
    }
}
</script>

<style lang="scss" scoped>
.page-loading {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
}
</style>